module.exports = __webpack_public_path__ + "media/images/group-circle-d11a9bcd98b0c6fc873974fb13c062d5.png";